/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-unused-state */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import {
  getEmployeesInCustomerSupport,
  scoreAgent,
} from '../../../../../actions/customer-support/quality-assurance/AgentsActions';

class ScoreAgent extends Component {
  static propTypes = {
    getEmployeesInCustomerSupport: PropTypes.func.isRequired,
    agents: PropTypes.array.isRequired,
    scoreAgent: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      employee: '',
      extension: '',
      greetings: '',
      resolution: '',
      knowledge: '',
      feedback: '',
      communtication_skills: '',
      problem_solving: '',
      process_adherence: '',
      closing: '',
      customer_experience: '',
      retention_pitch: '',
      listening_skills: '',
      retention_drive: '',
      load: false,
    };

    this.onChange = this.onChange.bind(this);
    this.scoreAgent = this.scoreAgent.bind(this);
  }

  scoringSections = [
    { 
      key: 'greetings', 
      name: 'Greetings', 
      description: 'OPENING AND CLOSING GREETINGS',
      required: true,
      maxScore: 20
    },
    { 
      key: 'resolution', 
      name: 'Resolution', 
      description: 'BUILDING RELATIONSHIP/COMMITMENT TO RESOLVING CUSTOMER\'S ISSUES',
      required: true,
      maxScore: 20
    },
    { 
      key: 'knowledge', 
      name: 'Knowledge', 
      description: 'KNOWLEDGE OF PRODUCTS AND SERVICES/OPERATIONS',
      required: true,
      maxScore: 20
    },
    { 
      key: 'communtication_skills', 
      name: 'Communication Skills', 
      description: 'COMMUNICATION SKILLS',
      required: false,
      maxScore: 20
    },
    { 
      key: 'problem_solving', 
      name: 'Problem Solving', 
      description: 'PROBLEM SOLVING AND TROUBLESHOOTING',
      required: false,
      maxScore: 20
    },
    { 
      key: 'process_adherence', 
      name: 'Process Adherence', 
      description: 'PROCESS ADHERENCE',
      required: false,
      maxScore: 20
    },
    { 
      key: 'closing', 
      name: 'Closing', 
      description: 'CLOSING AND WRAP-UP',
      required: false,
      maxScore: 20
    },
    { 
      key: 'customer_experience', 
      name: 'Customer Experience', 
      description: 'CUSTOMER EXPERIENCE IMPACT',
      required: false,
      maxScore: 20
    },
    { 
      key: 'retention_pitch', 
      name: 'Retention Pitch', 
      description: 'RETENTION PITCH & VALUE COMMUNICATION',
      required: false,
      maxScore: 20
    },
    { 
      key: 'listening_skills', 
      name: 'Listening Skills', 
      description: 'LISTENING SKILLS',
      required: false,
      maxScore: 20
    },
    { 
      key: 'retention_drive', 
      name: 'Retention Drive', 
      description: 'RETENTION DRIVE',
      required: false,
      maxScore: 20
    }
  ];

  componentDidMount() {
    this.props.getEmployeesInCustomerSupport();
  }

  onChange = (e) => {
    const value = e.target.type === 'number' ? Number(e.target.value) : e.target.value;
    this.setState({
      [e.target.name]: value,
    });
  };

  scoreAgent = (e) => {
    e.preventDefault();

    if (!this.submitForm()) {
      toast.error('Please fill in all required fields');
      return;
    }

    this.setState({ load: true });

    const { 
      employee, 
      extension, 
      greetings,
      resolution,
      knowledge,
      feedback,
      communtication_skills,
      problem_solving,
      process_adherence,
      closing,
      customer_experience,
      retention_pitch,
      listening_skills,
      retention_drive
    } = this.state;

    const scoreData = {
      employee_id: employee,
      extension: parseInt(extension, 10),
      greetings: parseInt(greetings, 10),
      resolution: parseInt(resolution, 10),
      knowledge: parseInt(knowledge, 10),
      feedback: feedback.trim(),
    };

    if (communtication_skills !== '' && communtication_skills !== null && communtication_skills !== undefined) {
      scoreData.communtication_skills = parseInt(communtication_skills, 10);
    }
    if (problem_solving !== '' && problem_solving !== null && problem_solving !== undefined) {
      scoreData.problem_solving = parseInt(problem_solving, 10);
    }
    if (process_adherence !== '' && process_adherence !== null && process_adherence !== undefined) {
      scoreData.process_adherence = parseInt(process_adherence, 10);
    }
    if (closing !== '' && closing !== null && closing !== undefined) {
      scoreData.closing = parseInt(closing, 10);
    }
    if (customer_experience !== '' && customer_experience !== null && customer_experience !== undefined) {
      scoreData.customer_experience = parseInt(customer_experience, 10);
    }
    if (retention_pitch !== '' && retention_pitch !== null && retention_pitch !== undefined) {
      scoreData.retention_pitch = parseInt(retention_pitch, 10);
    }
    if (listening_skills !== '' && listening_skills !== null && listening_skills !== undefined) {
      scoreData.listening_skills = parseInt(listening_skills, 10);
    }
    if (retention_drive !== '' && retention_drive !== null && retention_drive !== undefined) {
      scoreData.retention_drive = parseInt(retention_drive, 10);
    }

    const selectedAgent = this.props.agents.find(agent => agent.id == employee);
    
    if (!selectedAgent) {
      toast.error('Selected employee not found. Please refresh the page and try again.');
      this.setState({ load: false });
      return;
    }

    this.props.scoreAgent(scoreData);
  };

  submitForm = () => {
    const { 
      employee, 
      extension, 
      greetings,
      resolution,
      knowledge,
      feedback
    } = this.state;

    return employee !== '' && 
           employee !== null &&
           employee !== undefined &&
           extension !== '' && 
           extension !== null &&
           extension !== undefined &&
           greetings !== '' && 
           greetings !== null &&
           greetings !== undefined &&
           resolution !== '' && 
           resolution !== null &&
           resolution !== undefined &&
           knowledge !== '' && 
           knowledge !== null &&
           knowledge !== undefined &&
           feedback !== null &&
           feedback !== undefined &&
           feedback.trim().length > 0;
  };

  calculateTotalScore = () => {
    const scores = this.scoringSections.map(section => {
      const score = this.state[section.key];
      return score !== '' ? Number(score) : 0;
    });

    return scores.reduce((total, score) => total + (isNaN(score) ? 0 : score), 0);
  };

  generateScoreOptions = (maxScore) => {
    const options = [];
    for (let i = 0; i <= maxScore; i++) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return options;
  };

  renderScoringTable = () => {
    const totalScore = this.calculateTotalScore();

    return (
      <table className="table score-agent-table copy-font">
        <thead>
          <tr>
            <th>Section</th>
            <th>Description</th>
            <th nowrap="no-wrap">Score</th>
            <th>Required</th>
          </tr>
        </thead>
        <tbody>
          {this.scoringSections.map((section) => (
            <React.Fragment key={section.key}>
              <tr>
                <td nowrap="no-wrap">
                  <b>{section.name}</b>
                </td>
                <td>{section.description}</td>
                <td>
                  <select 
                    className="form-control" 
                    onChange={this.onChange} 
                    name={section.key}
                    value={this.state[section.key]}
                    required={section.required}
                  >
                    <option value="">Select Score</option>
                    {this.generateScoreOptions(section.maxScore)}
                  </select>
                </td>
                <td>
                  {section.required ? (
                    <span className="text-danger">*</span>
                  ) : (
                    <span className="text-muted"></span>
                  )}
                </td>
              </tr>
              <tr>
                <td />
              </tr>
            </React.Fragment>
          ))}

          <tr>
            <td />
            <td className="mt-5">
              <b>Total Score</b>
            </td>
            <td className="ml-5">
              <b>{totalScore}</b>
            </td>
            <td />
          </tr>
          
          <tr>
            <th>Feedback</th>
            <td colSpan="3">
              <textarea
                rows="6"
                cols="50"
                name="feedback"
                onChange={this.onChange}
                value={this.state.feedback}
                placeholder="Write feedback about this rating (Required)"
                className="form-control"
                required
              />
            </td>
          </tr>
          
          <tr>
            <td />
            {this.state.load ? (
              <td className="text-center" colSpan="3">
                <button className="btn btn-green" type="submit" disabled>
                  Scoring...
                </button>
              </td>
            ) : (
              <td className="text-center" colSpan="3">
                <button 
                  className="btn btn-green" 
                  type="submit" 
                  disabled={!this.submitForm()}
                >
                  Score Agent
                </button>
              </td>
            )}
          </tr>
        </tbody>
      </table>
    );
  };

  render() {
    const { extension, load } = this.state;
    const { agents } = this.props;

    return (
      <div
        id="score-agent"
        className="modal fade in"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title text-center" id="myModalLabel">
                Score Agent
              </h4>
              <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                ×
              </button>
            </div>
            <form onSubmit={this.scoreAgent}>
              <div className="modal-body">
                <div className="row mb-4">
                  <div className="col-md-6">
                    <label className="copy-font m-0 p-0">
                      Agent Name <span className="text-danger">*</span>
                    </label>
                    <select 
                      className="form-control" 
                      onChange={this.onChange} 
                      name="employee"
                      value={this.state.employee}
                      required
                    >
                      <option value="">Select Agent</option>
                      {agents.filter(agent => agent.id && agent.firstName && agent.lastName).map((agent) => {
                        return (
                          <option key={agent.id} value={agent.id}>
                            {agent.firstName.toUpperCase()} {agent.lastName.toUpperCase()}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="copy-font m-0 p-0">
                      Extension <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      onChange={this.onChange}
                      name="extension"
                      value={extension}
                      placeholder="Enter extension number"
                      required
                    />
                  </div>
                </div>

                {this.renderScoringTable()}
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  agents: state.employeesByDepartment.employeesByDepartment,
});

export default connect(
  mapStateToProps,
  {
    getEmployeesInCustomerSupport,
    scoreAgent,
  },
)(ScoreAgent);